/* istanbul ignore file */

import type { FocusEvent } from 'react';
import React from 'react';
import type { DropDownProps as RibbonsDropDownProps } from '@noths/polaris-client-ribbons-design-system';
import { DropDown as RibbonsDropDown } from '@noths/polaris-client-ribbons-design-system';

import { useTracking } from 'src/hooks/useTracking/useTracking';

interface DropdownProps extends RibbonsDropDownProps {
  'data-position': string;
  'data-section': string;
  name: string;
}

export const Dropdown = (props: DropdownProps) => {
  const { trackCompleted, trackFocusOnce } = useTracking();
  const { onChange: delegatedOnChange, onFocus: delegatedOnFocus } = props;

  const onFocus = (event: FocusEvent<HTMLSelectElement>) => {
    trackFocusOnce(event);

    if (delegatedOnFocus) {
      delegatedOnFocus(event);
    }
  };

  const onChange = (event: FocusEvent<HTMLSelectElement>) => {
    trackCompleted(event);

    if (delegatedOnChange) {
      delegatedOnChange(event);
    }
  };

  return <RibbonsDropDown {...props} onChange={onChange} onFocus={onFocus} />;
};
